import { utils } from './_utils.js';
import playLottie from "./_playLottie";
var intro = function intro() {
  var kvAnime = document.getElementById('js-kvAnime');
  var TL = gsap.timeline();
  var showUI = function showUI() {
    var header = document.getElementById('js-header');
    header.classList.remove('is-hidden-intro');
  };
  TL.to('.js-kvTitle', {
    stagger: utils.duration * 0.3,
    ease: utils.easing,
    y: 0
  }, "+=".concat(utils.duration)).to(kvAnime, {
    duration: utils.duration,
    ease: utils.easing,
    opacity: 1,
    y: 0
  }, "+=".concat(utils.duration * 0.5)).call(function () {
    return playLottie(kvAnime);
  }, null, '<').call(showUI, null, '>');
};
export default intro;